import axios, { AxiosResponse } from "axios"

import {
  CampaignRulesListRequest,
  CampaignRulesListResponse,
  CampaignRuleCreateRequest,
  CampaignRuleCreateResponse,
  CampaignRuleTestRequest,
  CampaignRuleTestResponse,
  CampaignRuleGetResponse,
  CampaignRuleUpdateRequest,
  CampaignRuleUpdateResponse,
  DictionariesRequest,
  DictionariesResponse,
  CampaignRuleStatusRequest,
  CampaignRuleStatusResponse,
  CampaignRuleArchiveRequest,
  CampaignRuleArchiveResponse,
  ActionsHistoryRequest,
  ActionsHistoryResponse,
  CampaignItemsRequest,
  CampaignItemsResponse,
} from "../../../../pages/ads-rules/types"
import { axiosConfigAuth } from "../middleware"
import {
  API_CAMPAIGN_RULES_LIST,
  API_CAMPAIGN_RULES_CREATE,
  API_CAMPAIGN_RULES_TEST,
  API_CAMPAIGN_RULES_GET,
  API_CAMPAIGN_RULES_UPDATE,
  API_CAMPAIGN_RULES_DICTIONARIES,
  API_CAMPAIGN_RULES_STATUS,
  API_CAMPAIGN_RULES_ARCHIVE,
  API_CAMPAIGN_RULES_ACTIONS_HISTORY,
  API_CAMPAIGN_RULES_CAMPAIGN_ITEMS,
} from "../urls"

export const adsRulesApi = {
  fetchRulesList: async (
    params: CampaignRulesListRequest
  ): Promise<AxiosResponse<CampaignRulesListResponse>> => {
    return axios.post(API_CAMPAIGN_RULES_LIST, params, axiosConfigAuth())
  },

  createRule: async (
    params: CampaignRuleCreateRequest
  ): Promise<AxiosResponse<CampaignRuleCreateResponse>> => {
    return axios.post(API_CAMPAIGN_RULES_CREATE, params, axiosConfigAuth())
  },

  testRule: async (
    params: CampaignRuleTestRequest
  ): Promise<AxiosResponse<CampaignRuleTestResponse>> => {
    return axios.post(API_CAMPAIGN_RULES_TEST, params, axiosConfigAuth())
  },

  getRule: async (
    ruleId: number
  ): Promise<AxiosResponse<CampaignRuleGetResponse>> => {
    return axios.get(API_CAMPAIGN_RULES_GET(ruleId), axiosConfigAuth())
  },

  updateRule: async (
    ruleId: number,
    params: CampaignRuleUpdateRequest
  ): Promise<AxiosResponse<CampaignRuleUpdateResponse>> => {
    return axios.put(
      API_CAMPAIGN_RULES_UPDATE(ruleId),
      params,
      axiosConfigAuth()
    )
  },

  fetchDictionaries: async (
    params?: DictionariesRequest
  ): Promise<AxiosResponse<DictionariesResponse>> => {
    const queryParams = params?.dictionaries
      ? `?dictionaries=${params.dictionaries}`
      : ""
    return axios.get(
      `${API_CAMPAIGN_RULES_DICTIONARIES}${queryParams}`,
      axiosConfigAuth()
    )
  },
  updateRuleStatus: async (
    ruleId: number,
    data: CampaignRuleStatusRequest
  ): Promise<AxiosResponse<CampaignRuleStatusResponse>> => {
    return axios.patch(
      API_CAMPAIGN_RULES_STATUS(ruleId),
      data,
      axiosConfigAuth()
    )
  },
  updateRuleArchive: async (
    ruleId: number,
    data: CampaignRuleArchiveRequest
  ): Promise<AxiosResponse<CampaignRuleArchiveResponse>> => {
    return axios.patch(
      API_CAMPAIGN_RULES_ARCHIVE(ruleId),
      data,
      axiosConfigAuth()
    )
  },
  fetchActionsHistory: async (
    params: ActionsHistoryRequest
  ): Promise<AxiosResponse<ActionsHistoryResponse>> => {
    return axios.post(
      API_CAMPAIGN_RULES_ACTIONS_HISTORY,
      params,
      axiosConfigAuth()
    )
  },
  fetchCampaignItems: async (
    params: CampaignItemsRequest
  ): Promise<AxiosResponse<CampaignItemsResponse>> => {
    return axios.post(
      API_CAMPAIGN_RULES_CAMPAIGN_ITEMS,
      params,
      axiosConfigAuth()
    )
  },
}
